<app-contact-banner></app-contact-banner>
<div class="rounded-lg bg-brand-100 max-h-[90vh] overflow-y-auto overscroll-contain">
  <div class="container mx-auto px-4 py-8">
    <div class="max-w-6xl mx-auto">
      <!-- Header -->
      <div class="text-center lg:mb-12">
        <h1 class="text-lg lg:text-2xl font-bold text-foreground lg:mb-4">Welcome to {{ brand.productName }}</h1>
        <p class="text-sm lg:text-lg text-gray-600">Log in to your account to continue</p>
      </div>

      <!-- Main Content -->
      <div class="grid md:grid-cols-2 gap-4 lg:gap-12 items-stretch">
        <!-- Login Form - Left Side -->
        <div class="dialog-panel-tile flex flex-col justify-between p-8 text-white h-full">
          <div>
            <h2 class="text-base lg:text-lg font-bold mb-6">Log In</h2>
            <form class="space-y-6" (ngSubmit)="login()">
              <div>
                <label class="block text-sm font-medium mb-1 text-gray-200" for="username"> E-Mail </label>
                <input
                  class="w-full px-3 py-2 border border-gray-300 bg-white text-foreground focus:outline-hidden focus:ring-2 focus:ring-ring focus:border-brand-500"
                  data-testid="signup-dialog-email"
                  id="username"
                  name="userName"
                  placeholder="Enter your email"
                  required
                  type="email"
                  [(ngModel)]="loginData.userName" />
              </div>
              <div>
                <label class="block text-sm font-medium mb-1 text-gray-200" for="password"> Password </label>
                <input
                  class="w-full px-3 py-2 border border-gray-300 bg-white text-foreground focus:outline-hidden focus:ring-2 focus:ring-ring focus:border-brand-500"
                  data-testid="signup-dialog-password"
                  id="password"
                  name="password"
                  placeholder="Enter your password"
                  required
                  type="password"
                  [(ngModel)]="loginData.password" />
              </div>
              <div class="flex items-center justify-between">
                <a
                  class="text-white hover:text-brand-300 underline text-sm cursor-pointer"
                  data-testid="signup-dialog-forgot-password-link"
                  (click)="goToRequestPassword()">
                  Forgot your password?
                </a>
              </div>
              @if (showError) {
                <div class="bg-red-900/50 border border-red-700 text-red-200 px-4 py-3">
                  <strong>You have not registered yet or your password is incorrect!</strong>
                </div>
              }

              <button
                class="bg-brand-500 hover:bg-brand-700 disabled:bg-gray-400 py-2 px-4 tracking-widest text-white font-semibold transition-colors duration-200 w-full"
                data-testid="signup-dialog-login-button"
                type="submit"
                [disabled]="isLoading">
                @if (isLoading) {
                  Signing In...
                } @else {
                  LOGIN
                }
              </button>
            </form>
          </div>
        </div>

        <!-- Signup Info - Right Side -->
        <div class="flex flex-col justify-between p-8 border-2 border-border rounded-lg h-full bg-white">
          <div>
            <h2 class="text-lg font-bold mb-6 text-foreground">Don't have an account yet?</h2>
            <div class="hidden lg:flex space-y-4 mb-8">
              <p class="text-lg text-gray-700">
                Create your free account to unlock unlimited access to exclusive research, newsletters and events.
              </p>
            </div>
          </div>
          <div class="text-center">
            <p class="text-sm text-gray-500">Create your free account in just 60 seconds</p>
            <button
              class="bg-brand-500 hover:bg-brand-700 py-2 px-6 tracking-widest text-white font-semibold transition-colors duration-200 w-full"
              data-testid="signup-dialog-create-account-button"
              (click)="goToSignup()">
              CREATE ACCOUNT
            </button>
          </div>
        </div>
      </div>

      <div class="w-full my-4 text-center">
        <button
          class="text-gray-muted hover:underline"
          data-testid="continue-without-account-button"
          (click)="continueWithoutAccount()">
          Accept cookies and continue without account (soon discontinued)
        </button>

        <p class="text-xs text-gray-muted">
          <i
            >mwb research uses cookies to track and improve site usage patterns. For more information, see the
            <a class="underline" href="https://www.research-hub.de/datenschutz"> Privacy Policy </a>. You can revoke
            your consent at any time in the footer.</i
          >
        </p>
      </div>
    </div>
  </div>
</div>
